import { useState, useCallback, useContext } from "react";
import { ReactReduxContext } from 'react-redux';
import { setStateClearFilters } from "../actions/index";

const LIST_FILTERS = [
  { label: `Track`, type: `track_name`, uid: `title`, bp: `name`, type_factory: 'text', shrink: 1 },
  { label: `Artist`, type: `artists_s`, uid: `artists_s`, bp: `artist_name`, type_factory: 'text', shrink: 1 },
  { label: `Label`, type: `label`, uid: `label`, bp: `label_name`, type_factory: 'text', shrink: 1 },
  { label: `Genre`, type: `genre_s`, uid: `genre_s`, bp: `genre_name`, type_factory: 'text', shrink: 1 },
  { label: `Sub-genre`, type: `sub_genre`, uid: `sub_genre`, bp: `sub_genre`, type_factory: 'text', shrink: 1 },
  { label: `Bpm`, type: `bpm`, uid: `bpm`, bp: `bpm`, type_factory: 'text', inputType: 'number', shrink: 6 },
  { label: `Key`, type: `key`, uid: `key_camelot`, bp: `key_name`, type_factory: 'text', shrink: 6 },
  { label: `Key`, type: `key_convert`, uid: `key_camelot`, bp: `key_id`, type_factory: 'text', shrink: 6 },
  { label: `Mix`, type: `mix_name`, uid: `mix_name`, bp: `mix_name`, type_factory: 'text', shrink: 1 },
  { label: `Track`, type: `genre_track_name`, uid: `genre_track_name`, bp: `name`, type_factory: 'text', shrink: 1 },
  { label: `Remixer`, type: `remixers_s`, uid: `remixers_s`, bp: `artist_name`, type_factory: 'text', shrink: 1 },
  { label: `Released`, type: `publish_date`, uid: `publish_date`, bp: `publish_date`, type_factory: 'date', shrink: 1 },
  { label: `Chart`, type: `chart_name`, uid: `name`, bp: `name`, type_factory: 'text', shrink: 1 },
  { label: `Release`, type: `release_name`, uid: `release_name`, bp: `name`, type_factory: 'text', shrink: 1 },
  { label: `Artists`, type: `dj_name`, uid: `dj_name`, bp: `dj_name`, type_factory: 'text', shrink: 1 },
  { label: `Pre-orders`, type: `preorders`, uid: `preorders`, bp: `preorder`, type_factory: 'toggle', shrink: 1 }
]
// Date YYYY-MM-DD:YYYY-MM-DD

const useFilters = (list) => {
  const { store } = useContext(ReactReduxContext);
  const { dispatch } = store;
  const [isFirst, setFirst] = useState(true);

  const getKeyID = useCallback((camelot) => {
    const conversionTable = [
      { camelot: `1A`, ids: [1, 32] },
      { camelot: `2A`, ids: [2, 30] },
      { camelot: `3A`, ids: [3, 26] },
      { camelot: `4A`, ids: [4] },
      { camelot: `5A`, ids: [5] },
      { camelot: `6A`, ids: [6] },
      { camelot: `7A`, ids: [7] },
      { camelot: `8A`, ids: [8] },
      { camelot: `9A`, ids: [9] },
      { camelot: `10A`, ids: [10] },
      { camelot: `11A`, ids: [11, 34] },
      { camelot: `12A`, ids: [12, 28] },
      { camelot: `1B`, ids: [13] },
      { camelot: `2B`, ids: [14, 33] },
      { camelot: `3B`, ids: [15, 27] },
      { camelot: `4B`, ids: [16, 31] },
      { camelot: `5B`, ids: [17, 29] },
      { camelot: `6B`, ids: [18, 25] },
      { camelot: `7B`, ids: [19] },
      { camelot: `8B`, ids: [20] },
      { camelot: `9B`, ids: [21] },
      { camelot: `10B`, ids: [22] },
      { camelot: `11B`, ids: [23] },
      { camelot: `12B`, ids: [24] }
    ]
    const e = conversionTable.find( x => x.camelot === camelot.toUpperCase() );
    return e ? e.ids.join(',') : '';
  }, []);

  const prepareList = list.map( type => {
    const filter = LIST_FILTERS.find( o => o.type === type );
    return { ...filter, value: `` };
  })
  const [filters, setFilters] = useState(prepareList);

  const onClearFilters = () => {
    setFilters([...filters.map( x => { x.value = ''; return x } )]);
    dispatch(setStateClearFilters(false));
  }

  const onValidFilters = (type, value) => {
    setFirst(false);
    const xFilters = [...filters];
    let filter = xFilters.find( x => x.type === type );
    filter.value = value;
    setFilters([...xFilters]);
    dispatch(setStateClearFilters(true));
  }

  const getFiltersFormatted = useCallback(() => {
    return filters.reduce( (path, x) => {
      path += (x.value) ? `&${x.bp}=${ (x.type !== `key_convert`) ? x.value : getKeyID(x.value) }` : '';
      return path;
    }, '');
  }, [filters, getKeyID]);

  const getLocalFilters = () => {
    return filters.reduce( (path, x) => {
      path += (x.value) ? `&${x.uid}=${x.value}` : '';
      return path;
    }, '');
  }

  const byFilters = (item) => filters.every( filter => (item[filter.uid]) ? item[filter.uid].toLowerCase().includes(filter.value.toLowerCase()) || filter.value === '' : true ) ;

  return { listFilters: filters, getFiltersFormatted, getLocalFilters, onValidFilters, onClearFilters, byFilters, isFirst };
};

export default useFilters;
